import Content from "@components/CustomTypography/Content/Content"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Overlay from "@components/CustomTypography/Overlay/Overlay"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import {Size} from "@components/WebsiteRevamp/Typography/Typography"
import {contentSize} from "@customTypes/customTypes"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"

import ContainerWrapper from "../Wrappers/ContainerWrapper/ContainerWrapper"

import styles from "./FullWidthHeader.module.scss"

const FullWidthHeader = (props: {
	data: AdvancedSideAssetMainContent
	size?: contentSize
	className?: string
	textColor?: "black" | "white"
	withOverlay?: boolean
	position: "left" | "rigth" | "center"
}) => {
	const positionClass = styles[props.position]

	const type = props.data.preview?.type || "none"

	const typeClass = styles[type]

	const contentClass = `${styles.video__content} ${positionClass} ${typeClass} `
	// const buttonsClass = `${styles.video__content_buttons} ${positionClass}`

	return (
		<>
			<Separator
				backgroundColor={type === "none" ? "#F8FAFE" : "transparent"}
				withoutMeasure
			>
				<div className={`${styles.backgroundVideo} ${typeClass} `}>
					<div className={styles.content__container}>
						<ContainerWrapper
							className={`${styles.contentBox}  ${positionClass}`}
						>
							<div
								className={contentClass}
								style={{color: props.textColor}}
							>
								<Content
									data={props.data}
									titleProps={{
										as: "h1",
										size: Size.XXL,
									}}
									subtitleProps={{
										size: Size.XS,
										noPadding: true,
									}}
								/>
								{props.data?.buttons &&
									props.data?.buttons?.length > 0 && (
										<>
											<Separator size={16} />
											<ButtonContainer>
												<ButtonSwitcher
													buttonsList={props.data}
													popup={{
														type: "asset",
														data: props.data,
													}}
													withoutTarget
												/>
											</ButtonContainer>
										</>
									)}
							</div>
						</ContainerWrapper>
					</div>
					{type === "video" && (
						<video
							className={styles.videoBackground}
							controls={false}
							autoPlay
							loop
							muted
							playsInline
						>
							<source
								src={props.data.preview?.src}
								type={"video/mp4"}
							/>
						</video>
					)}

					{type === "image" && props.data.preview && (
						<NewResponsiveImage
							imageClassName={styles.imageContainer}
							withoutContainer
							{...props.data.preview}
							alt={props.data.title ?? props.data.preview?.alt}
						/>
					)}

					{props.withOverlay && <Overlay />}
				</div>
			</Separator>
		</>
	)
}

export default FullWidthHeader
